<section>
  <div class="container">
    <div class="row center-lg center-xs">
      <div class="col-xs-12-col-lg-12">
        <app-title [titles]="[title()]" class="title" />
        <div [innerHTML]="data().html" class="text"></div>
      </div>
    </div>
  </div>
</section>
